import { render, staticRenderFns } from "./EndTestPopUp.vue?vue&type=template&id=67fa48c5&scoped=true&"
import script from "./EndTestPopUp.vue?vue&type=script&lang=js&"
export * from "./EndTestPopUp.vue?vue&type=script&lang=js&"
import style0 from "./EndTestPopUp.vue?vue&type=style&index=0&id=67fa48c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa48c5",
  null
  
)

export default component.exports